
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.773 6.282v1.617a.808.808 0 01-.808.808H1.308A.808.808 0 01.5 7.899V2.242a.808.808 0 01.808-.808h1.616M4.864.707H8.5v3.636M8.5.707L4.136 5.071"}})])])
          )
        }
      }
    